import { formatNumberWithSpaces } from '@medicusunion/front-utils';
import dayjs from 'dayjs';
import { store } from 'store';
import {
  selectAnalyticsCommission,
  selectAnalyticsDynamics
} from 'store/analytics/selectors';

import { money } from 'utils/price';

function escapeCSVValue(value: string | number): string {
  const safeValue = String(value).replace(/"/g, '""'); // escape quotes

  return `"${safeValue}"`;
}

// TODO: The exact data received from Google is currently uncertain.
// Ensure the date is displayed correctly for the next year.
export const getMonthName = (month: string) => {
  return dayjs(`2025-${month}-01`, 'YYYY-MM-DD').format('YYYY, MMMM');
};

const convertToCSV = (organization: string) => {
  const state = store.getState();
  const dynamics = selectAnalyticsDynamics(organization)(state);

  const headers = [
    'Date',
    'Users',
    'Total Orders',
    'Conversion Rate',
    'Revenue Share',
    'Monthly Subscriptions (Qty)',
    'Monthly Subscriptions (Price)',
    'Yearly Subscriptions (Qty)',
    'Yearly Subscriptions (Price)',
    'Video Consultations (Qty)',
    'Video Consultations (Price)',
    'Radiology (Qty)',
    'Radiology (Price)'
  ];

  const rows: string[] = [];

  dynamics.forEach(monthData => {
    const row = [
      getMonthName(monthData.month),
      formatNumberWithSpaces(+monthData.totalUsers),
      formatNumberWithSpaces(+monthData.transactions),
      `${formatNumberWithSpaces(
        +(monthData.conversionRate * 100).toFixed(2)
      )}%`,
      money(+monthData.revenue, { currency: 'USD' }),
      formatNumberWithSpaces(+monthData.subscription_monthly_quantity),
      money(+monthData.subscription_monthly_price, { currency: 'USD' }),
      formatNumberWithSpaces(+monthData.subscription_yearly_quantity),
      money(+monthData.subscription_yearly_price, { currency: 'USD' }),
      formatNumberWithSpaces(+monthData.video_consultation_quantity),
      money(+monthData.video_consultation_price, { currency: 'USD' }),
      formatNumberWithSpaces(+monthData.radiology_quantity),
      money(+monthData.radiology_price, { currency: 'USD' })
    ];

    rows.push(row.map(escapeCSVValue).join(','));
  });

  return [headers.map(escapeCSVValue).join(','), ...rows].join('\n');
};

export const downloadDynamicsCSV = (organization: string) => {
  const csv = convertToCSV(organization);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const state = store.getState();
  const commission = selectAnalyticsCommission(state);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute(
    'download',
    `${commission ? 'revenue_commission_' : ''}monthly-analytics.csv`
  );
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
